import { usePWAStore } from "@base/common/libs/stores/index.js";

export const NATIVE_PLATFORM = {
  IOS: "ios",
  ANDROID: "android"
};

export function getPlatform() {
  let data = usePWAStore.getState().getDeviceInfo() || {};
  return data.platform;
}

export function isIOS() {
  return getPlatform() === NATIVE_PLATFORM.IOS;
}

export function getHostName() {
  return `https://${window.location.hostname}`;
}

export function openFiles() {
  window.open("shareddocuments://");
}

export function isIOSWeb() {
  return (
    !!navigator.platform &&
    /iPhone|iPod|iPad/.test(navigator.platform) &&
    !window.MSStream
  );
}

export function isAndroid() {
  return getPlatform() === NATIVE_PLATFORM.ANDROID;
}
